import { DeviceDAO } from '../../../data/SystemManagementDAO';
export const checkHierarchy = async (device, contextUser, contextCustomer) => {
    if (device && contextUser && contextCustomer) {
        const allocatablePromise = await DeviceDAO.deviceIsAllocatableThroughHierarchy({
            installCustomer: contextCustomer,
            device: device,
        });
        if (allocatablePromise.err !== null) {
            return allocatablePromise.err.message;
        }
        else {
            return undefined;
        }
    }
};
